// extracted by mini-css-extract-plugin
module.exports = {"root":"bmi-chart_root__2d_v3","chart":"bmi-chart_chart__3F4Sc"};